import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';

export default function AnswerCard({ answer }) {
  const [upvotes, setUpvotes] = useState(answer.upvotes);
  const [hasVoted, setHasVoted] = useState(false);

  const handleVote = () => {
    if (hasVoted) {
      setUpvotes(up => up - 1);
    } else {
      setUpvotes(up => up + 1);
    }
    setHasVoted(!hasVoted);
  };

  return (
    <div className={`p-6 md:p-8 rounded-3xl border transition-all ${
      answer.isCurated 
        ? 'bg-brand-gold/5 border-brand-gold/40 shadow-gold-glow' 
        : 'bg-[var(--bg-surface)] border-[var(--border-subtle)]'
    }`}>
      
      {/* Header Oficial (Si es curada) */}
      {answer.isCurated && (
        <div className="flex items-center gap-2 mb-6 pb-4 border-b border-brand-gold/20">
          <div className="flex items-center justify-center w-6 h-6 rounded-full bg-brand-gold">
            <SafeIcon name="Award" className="w-3.5 h-3.5 text-white" />
          </div>
          <span className="text-xs font-black text-brand-gold-dark uppercase tracking-[0.2em]">
            Respuesta Oficial Curada
          </span>
        </div>
      )}

      <div className="flex gap-6">
        {/* Votación */}
        <div className="flex flex-col items-center gap-2 shrink-0">
          <button 
            onClick={handleVote}
            className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${
              hasVoted 
                ? 'bg-brand-cyan text-white shadow-md transform scale-110' 
                : 'bg-[var(--bg-base)] text-[var(--text-secondary)] hover:bg-brand-cyan/10 hover:text-brand-cyan'
            }`}
          >
            <SafeIcon name="ChevronUp" className="w-6 h-6" />
          </button>
          <span className={`text-sm font-black ${hasVoted ? 'text-brand-cyan' : 'text-[var(--text-secondary)]'}`}>
            {upvotes}
          </span>
        </div>

        {/* Contenido de la Respuesta */}
        <div className="flex-1">
          <p className="text-[var(--text-main)]/90 text-sm md:text-base leading-relaxed font-medium mb-6">
            {answer.text}
          </p>

          {/* Autor */}
          <div className="flex items-center justify-between pt-4 border-t border-[var(--border-subtle)]">
            <div className="flex items-center gap-3">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center text-xs font-black text-white ${
                answer.isCurated ? 'gfi-gradient-bg' : 'bg-brand-navy'
              }`}>
                {answer.avatar}
              </div>
              <div>
                <p className="text-xs font-black text-[var(--text-main)] uppercase tracking-tight">
                  {answer.author}
                </p>
                <p className="text-[9px] font-bold text-[var(--text-secondary)] uppercase tracking-widest mt-0.5">
                  {answer.role}
                </p>
              </div>
            </div>
            <span className="text-[10px] font-bold text-[var(--text-secondary)] uppercase tracking-widest hidden md:block">
              Respondido {answer.date}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}